import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Image from '@client/components/image/Image';
import { strings } from '@client/localization/Localization';
import styles from './displayBoxLogo.scss';

class DisplayBoxLogo extends PureComponent {
  getDisplayBoxLogoClassNames() {
    return classNames({
      [styles.logoCircle]: true,
      [this.props.className]: this.props.className,
    });
  }

  render() {
    const { logo, alt, logoMaxHeight, poweredByFontSize } = this.props;
    return (
      <div className={this.getDisplayBoxLogoClassNames()}>
        <div
          className={styles.poweredBy}
          style={{ fontSize: poweredByFontSize }}
        >
          {strings.poweredBy}
        </div>
        <Image
          className={styles.logo}
          style={{ maxHeight: logoMaxHeight }}
          src={logo}
          alt={alt}
        />
      </div>
    );
  }
}

DisplayBoxLogo.propTypes = {
  logo: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
  logoMaxHeight: PropTypes.string,
  poweredByFontSize: PropTypes.string,
};

DisplayBoxLogo.defaultProps = {
  logoMaxHeight: '35px',
};

export default DisplayBoxLogo;
